module.exports = __webpack_public_path__ + "media/mem_new_m.22c194da.mp4";